/** Las 9 sesiones del curriculum v1. */

import type { ClaveSesion, Sesion } from '../../tipos.js';
import { BASELINE } from './baseline.js';
import { CHECKPOINT } from './checkpoint.js';
import { D1 } from './d1.js';
import { D2 } from './d2.js';
import { D3 } from './d3.js';
import { D4 } from './d4.js';
import { D5 } from './d5.js';
import { D6 } from './d6.js';
import { D7 } from './d7.js';

export const SESIONES: Record<ClaveSesion, Sesion> = {
  baseline: BASELINE,
  d1: D1,
  d2: D2,
  d3: D3,
  d4: D4,
  d5: D5,
  d6: D6,
  d7: D7,
  checkpoint: CHECKPOINT,
};

export { BASELINE, CHECKPOINT, D1, D2, D3, D4, D5, D6, D7 };
